var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowView)?_c('div',{staticClass:"option-edit-group"},[_c('div',{staticClass:"text"},[_c('p',{staticClass:"left"},[_vm._v("已添加到自选")]),_c('p',{staticClass:"right",on:{"click":_vm.editGroup}},[_vm._v("编辑分组")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }